import moment from 'moment';

export const rfc3339 = (date: string) => moment(date).format();
